<template>
	<div class="">
		<vip v-if="$store.state.config.ui_type != 'bym'"></vip>
		<bym_vip v-else></bym_vip>
	</div>
</template>

<script>
	import vip from "./vip.vue"
	import bym_vip from "./bym_vip.vue"
	
	export default {
		computed:{
			
		},
		name: 'vip_index',
		components: {
			vip,
			bym_vip
		},
		// ui_version
		data() {
			return {
				
			}
		},
		created() {
			
		},
		mounted() {
		
		},
		beforeDestroy() {
		},
		methods: {
		
		}
	}
</script>
<style scoped>

</style>
